(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-faq-lp"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaqLp(section) {
    section.querySelectorAll('.gm-faq-lp__trigger').forEach(function (btn) {
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      if (!body) return;

      body.setAttribute('aria-hidden', 'true');

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        body.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      });
    });
  }

  document.querySelectorAll('.gm-faq-lp').forEach(initFaqLp);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.gm-faq-lp');
      if (section) initFaqLp(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BREAKPOINT = 767;
    var AUTO_DELAY = 3500;
    var RESUME_WAIT = 6000;

    function init(section) {
      var track = section.querySelector('.gm-ingredients__track');
      var slides = Array.prototype.slice.call(section.querySelectorAll('.gm-ingredients__slide'));
      var prevBtn = section.querySelector('.gm-ingredients__arrow--prev');
      var nextBtn = section.querySelector('.gm-ingredients__arrow--next');

      if (!track || !slides.length) return;

      var current = 0;
      var total = slides.length;
      var autoTimer = null;
      var resumeTimer = null;
      var isMobile = false;

      /* Activate first slide immediately */
      slides[0].classList.add('is-active');

      function render(idx) {
        slides[current].classList.remove('is-active');
        current = ((idx % total) + total) % total;
        slides[current].classList.add('is-active');
      }

      function startAuto() {
        clearInterval(autoTimer);
        autoTimer = setInterval(function () {
          render(current + 1);
        }, AUTO_DELAY);
      }

      function pause() {
        clearInterval(autoTimer);
        clearTimeout(resumeTimer);
        autoTimer = null;
      }

      function scheduleResume() {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(startAuto, RESUME_WAIT);
      }

      prevBtn.addEventListener('click', function () {
        render(current - 1);
        pause();
        scheduleResume();
      });

      nextBtn.addEventListener('click', function () {
        render(current + 1);
        pause();
        scheduleResume();
      });

      /* Swipe */
      var touchStartX = 0;
      var touchStartY = 0;
      var isSwipe = false;

      track.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          isSwipe = false;
          pause();
        },
        { passive: true }
      );

      track.addEventListener(
        'touchmove',
        function (e) {
          var dx = Math.abs(e.touches[0].clientX - touchStartX);
          var dy = Math.abs(e.touches[0].clientY - touchStartY);
          if (dx > dy && dx > 8) isSwipe = true;
        },
        { passive: true }
      );

      track.addEventListener(
        'touchend',
        function (e) {
          if (isSwipe) {
            var diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 36) render(current + (diff > 0 ? 1 : -1));
          }
          scheduleResume();
        },
        { passive: true }
      );

      /* Pause when out of viewport */
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && isMobile) {
              startAuto();
            } else {
              pause();
            }
          });
        },
        { threshold: 0.4 }
      );

      observer.observe(section);

      function onResize() {
        isMobile = window.innerWidth <= BREAKPOINT;
        if (isMobile) {
          if (!autoTimer) startAuto();
        } else {
          pause();
        }
      }

      window.addEventListener('resize', onResize, { passive: true });
      onResize();
    }

    document.querySelectorAll('.gm-ingredients[id]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-kit-builder-lp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parsePrice(raw) {
      if (!raw) return 0;
      var s = String(raw).replace(/[^\d,\.]/g, '');
      if (s.indexOf(',') > s.indexOf('.') && s.indexOf(',') !== -1) {
        s = s.replace(/\./g, '').replace(',', '.');
      }
      return parseFloat(s) || 0;
    }

    function toCents(num) {
      // única conversão decimal->inteiro do fluxo; daí em diante é só aritmética de inteiros, sem drift de float
      return Math.round(num * 100);
    }

    function formatCentsBRL(cents) {
      var neg = cents < 0;
      var abs = Math.abs(cents);
      var reais = Math.floor(abs / 100);
      var centavos = abs % 100;
      var intWithSep = String(reais).replace(/(\d)(?=(\d{3})+$)/g, '$1.');
      var centavosStr = centavos < 10 ? '0' + centavos : String(centavos);
      return (neg ? '-' : '') + 'R$ ' + intWithSep + ',' + centavosStr;
    }

    function KitBuilder(sectionId) {
      var el = document.querySelector('[data-section-id="' + sectionId + '"]');
      var configEl = document.getElementById('gm-kb-config-' + sectionId);
      if (!el || !configEl) return;

      var cfg;
      try {
        cfg = JSON.parse(configEl.textContent);
      } catch (e) {
        return;
      }
      if (!cfg.kits || !cfg.kits.length) return;

      var state = {
        kitIndex: 0,
        imgIndex: 0,
        qty: cfg.qtyMin || 1,
      };

      var mainImg = el.querySelector('[data-main-image]');
      var thumbsWrap = el.querySelector('[data-thumbs]');
      var kitBtns = el.querySelectorAll('[data-kit-index]');
      var qtyBtns = el.querySelectorAll('[data-qty]');
      var priceEl = el.querySelector('[data-price]');
      var priceUnitEl = el.querySelector('[data-price-unit]');
      var ctaBtn = el.querySelector('[data-checkout-btn]');
      var galleryPrev = el.querySelector('[data-gallery-prev]');
      var galleryNext = el.querySelector('[data-gallery-next]');
      var badgeEl = el.querySelector('[data-kit-badge]');

      function getValidImages() {
        return (cfg.kits[state.kitIndex].images || []).filter(Boolean);
      }

      function getValidThumbs() {
        return (cfg.kits[state.kitIndex].thumbnails || []).filter(Boolean);
      }

      function renderThumbs() {
        if (!thumbsWrap) return;
        thumbsWrap.innerHTML = '';
        getValidThumbs().forEach(function (src, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'gm-kb__thumb' + (i === state.imgIndex ? ' is-active' : '');
          btn.dataset.thumbIndex = i;
          btn.setAttribute('aria-label', 'Ver imagem ' + (i + 1));
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.width = 80;
          img.height = 80;
          img.loading = 'lazy';
          btn.appendChild(img);
          btn.addEventListener('click', function () {
            state.imgIndex = i;
            updateGallery();
          });
          thumbsWrap.appendChild(btn);
        });
      }

      function updateGallery() {
        var images = getValidImages();
        if (mainImg && images.length) {
          if (mainImg.tagName === 'IMG') {
            mainImg.src = images[state.imgIndex] || images[0];
            mainImg.alt = cfg.kits[state.kitIndex].name || '';
          }
        }

        var kit = cfg.kits[state.kitIndex];
        if (badgeEl) {
          if (kit.badge) {
            badgeEl.textContent = kit.badge;
            badgeEl.style.display = '';
          } else {
            badgeEl.style.display = 'none';
          }
        }

        renderThumbs();
      }

      function updatePrice() {
        var kit = cfg.kits[state.kitIndex];
        var unitCents = toCents(parsePrice(kit.priceOnetime)); // PARA: usado no cálculo do desconto
        var compareAtCents = toCents(parsePrice(kit.compareAtPriceOnetime)); // DE: usado no valor riscado
        var discountCents = kit.discounts ? parseInt(kit.discounts[String(state.qty)], 10) || 0 : 0; // já vem em centavos do schema
        var originalEl = el.querySelector('[data-price-original]');
        var savingsEl = el.querySelector('[data-savings]');
        var savingsAmountEl = el.querySelector('[data-savings-amount]');

        if (priceEl) {
          if (unitCents) {
            var deTotalCents = (compareAtCents > 0 ? compareAtCents : unitCents) * state.qty; // soma dos DE:
            var finalTotalCents = Math.max(0, unitCents * state.qty - discountCents); // PARA: com desconto aplicado
            var savingsCents = deTotalCents - finalTotalCents;

            priceEl.textContent = formatCentsBRL(finalTotalCents);
            if (savingsCents > 0) {
              if (originalEl) {
                originalEl.textContent = formatCentsBRL(deTotalCents);
                originalEl.style.display = '';
              }
              if (savingsEl) {
                savingsEl.style.display = '';
              }
              if (savingsAmountEl) {
                savingsAmountEl.textContent = formatCentsBRL(savingsCents);
              }
            } else {
              if (originalEl) originalEl.style.display = 'none';
              if (savingsEl) savingsEl.style.display = 'none';
            }
          } else {
            priceEl.textContent = '—';
            if (originalEl) originalEl.style.display = 'none';
            if (savingsEl) savingsEl.style.display = 'none';
          }
        }

        if (priceUnitEl && unitCents && state.qty > 1) {
          var totalFinalCents = Math.max(0, unitCents * state.qty - discountCents);
          priceUnitEl.textContent = formatCentsBRL(Math.round(totalFinalCents / state.qty)) + ' cada';
        } else if (priceUnitEl) {
          priceUnitEl.textContent = '';
        }
      }

      function renderStars(starsEl, rating) {
        var filled = Math.floor(rating);
        var ns = 'http://www.w3.org/2000/svg';
        starsEl.innerHTML = '';
        for (var i = 1; i <= 5; i++) {
          var svg = document.createElementNS(ns, 'svg');
          svg.setAttribute('class', 'gm-kb__star');
          svg.setAttribute('width', '22');
          svg.setAttribute('height', '22');
          svg.setAttribute('viewBox', '0 0 24 24');
          svg.setAttribute('fill', i <= filled ? 'var(--gm-kb-star)' : 'none');
          svg.setAttribute('stroke', 'var(--gm-kb-primary)');
          svg.setAttribute('stroke-width', '1.5');
          svg.setAttribute('stroke-linejoin', 'round');
          var path = document.createElementNS(ns, 'path');
          path.setAttribute(
            'd',
            'M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z'
          );
          svg.appendChild(path);
          starsEl.appendChild(svg);
        }
      }

      function updateRating() {
        var kit = cfg.kits[state.kitIndex];
        var starsEl = el.querySelector('[data-kit-stars]');
        var labelEl = el.querySelector('[data-kit-rating-label]');
        if (starsEl) renderStars(starsEl, kit.rating || 0);
        if (labelEl) {
          var r = kit.rating || 0;
          var c = kit.ratingCount || 0;
          if (r > 0) {
            var countStr = c > 0 ? ' (' + c.toLocaleString('pt-BR') + ')' : '';
            labelEl.textContent = r.toFixed(1) + '/5.0' + countStr;
          } else {
            labelEl.textContent = '';
          }
        }
      }

      function escapeHtml(str) {
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      }

      function updateDescription() {
        var kit = cfg.kits[state.kitIndex];

        var descEl = el.querySelector('[data-kit-description]');
        if (descEl) {
          var desc = kit.description || '';
          descEl.textContent = desc;
          descEl.style.display = desc ? '' : 'none';
        }

        var benefitsEl = el.querySelector('[data-kit-benefits]');
        if (benefitsEl) {
          var benefits = (kit.benefits || []).filter(Boolean);
          if (benefits.length) {
            benefitsEl.innerHTML = benefits
              .map(function (b) {
                return (
                  '<li class="gm-kb__benefit"><svg class="gm-kb__check" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' +
                  escapeHtml(b) +
                  '</span></li>'
                );
              })
              .join('');
            benefitsEl.style.display = '';
          } else {
            benefitsEl.innerHTML = '';
            benefitsEl.style.display = 'none';
          }
        }

        var featuresEl = el.querySelector('[data-kit-features]');
        if (featuresEl) {
          var features = (kit.features || []).filter(Boolean);
          if (features.length) {
            featuresEl.innerHTML = features
              .map(function (f) {
                return '<span class="gm-kb__feature">' + escapeHtml(f) + '</span>';
              })
              .join('');
            featuresEl.style.display = '';
          } else {
            featuresEl.innerHTML = '';
            featuresEl.style.display = 'none';
          }
        }

        updateRating();
      }

      function updateUI() {
        kitBtns.forEach(function (btn) {
          btn.classList.toggle('is-active', parseInt(btn.dataset.kitIndex) === state.kitIndex);
        });
        qtyBtns.forEach(function (btn) {
          btn.classList.toggle('is-active', parseInt(btn.dataset.qty) === state.qty);
        });
        updateGallery();
        updatePrice();
        updateDescription();
      }

      kitBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.kitIndex = parseInt(btn.dataset.kitIndex);
          state.imgIndex = 0;
          updateUI();
        });
      });

      qtyBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.qty = parseInt(btn.dataset.qty);
          updateUI();
        });
      });

      if (galleryPrev) {
        galleryPrev.addEventListener('click', function () {
          var imgs = getValidImages();
          if (!imgs.length) return;
          state.imgIndex = (state.imgIndex - 1 + imgs.length) % imgs.length;
          updateGallery();
        });
      }

      if (galleryNext) {
        galleryNext.addEventListener('click', function () {
          var imgs = getValidImages();
          if (!imgs.length) return;
          state.imgIndex = (state.imgIndex + 1) % imgs.length;
          updateGallery();
        });
      }

      if (ctaBtn) {
        ctaBtn.addEventListener('click', function () {
          var kit = cfg.kits[state.kitIndex];
          var variantId = kit.variantIdOnetime;
          var discountCode = (kit.coupons && kit.coupons[String(state.qty)]) || '';

          if (!variantId) {
            console.warn('[gm-kit-builder] Produto não configurado para este kit.');
            return;
          }

          ctaBtn.disabled = true;
          ctaBtn.classList.add('is-loading');

          // Cart permalink: substitui o carrinho e abre o checkout já com o item,
          // a quantidade e o cupom — sem depender de cookie nem de redirect encadeado.
          // Os attributes[] sobrevivem ao permalink e viram note_attributes do pedido,
          // que é o que o Shopify Flow lê para aplicar a tag de origem.
          var params = [];
          if (discountCode) {
            params.push('discount=' + encodeURIComponent(discountCode));
          }
          if (cfg.origem) {
            params.push('attributes[origem]=' + encodeURIComponent(cfg.origem));
          }
          if (kit.name) {
            params.push('attributes[kit]=' + encodeURIComponent(kit.name));
          }

          var checkoutUrl = '/cart/' + variantId + ':' + state.qty;
          if (params.length) {
            checkoutUrl += '?' + params.join('&');
          }
          window.location.href = checkoutUrl;
        });
      }

      updateUI();
    }

    function processQueue() {
      var queue = window.__gmKbQueue || [];
      queue.forEach(function (id) {
        new KitBuilder(id);
      });
      window.__gmKbQueue = {
        push: function (id) {
          new KitBuilder(id);
        },
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', processQueue);
    } else {
      processQueue();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var AUTO_DELAY  = 4000;
  var RESUME_WAIT = 6000;

  function init(section) {
    var track  = section.querySelector('.gm-testimonials__track');
    var slides = Array.prototype.slice.call(section.querySelectorAll('.gm-testimonials__slide'));

    if (!track || !slides.length) return;

    var current     = 0;
    var total       = slides.length;
    var autoTimer   = null;
    var resumeTimer = null;
    var isMobile    = false;

    slides[0].classList.add('is-active');

    function render(idx) {
      slides[current].classList.remove('is-active');
      current = ((idx % total) + total) % total;
      slides[current].classList.add('is-active');
    }

    function startAuto() {
      clearInterval(autoTimer);
      autoTimer = setInterval(function () { render(current + 1); }, AUTO_DELAY);
    }

    function pause() {
      clearInterval(autoTimer);
      clearTimeout(resumeTimer);
      autoTimer = null;
    }

    function pauseAndResume() {
      pause();
      resumeTimer = setTimeout(startAuto, RESUME_WAIT);
    }

    /* Click: metade esquerda = anterior, metade direita = próximo */
    track.addEventListener('click', function (e) {
      var rect = track.getBoundingClientRect();
      var mid  = rect.left + rect.width / 2;
      render(e.clientX < mid ? current - 1 : current + 1);
      pauseAndResume();
    });

    /* Swipe support */
    var touchStartX = 0;
    var touchStartY = 0;
    var isSwipe     = false;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwipe     = false;
      pause();
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      if (dx > dy && dx > 8) isSwipe = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (isSwipe) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 36) render(current + (diff > 0 ? 1 : -1));
      }
      resumeTimer = setTimeout(startAuto, RESUME_WAIT);
    }, { passive: true });

    /* Pause when out of viewport */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && isMobile) {
          startAuto();
        } else {
          pause();
        }
      });
    }, { threshold: 0.4 });

    observer.observe(section);

    function onResize() {
      isMobile = window.innerWidth <= 767;
      if (isMobile) {
        if (!autoTimer) startAuto();
      } else {
        pause();
      }
    }

    window.addEventListener('resize', onResize, { passive: true });
    onResize();
  }

  document.querySelectorAll('.gm-testimonials[id]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

 document.addEventListener('DOMContentLoaded', () => {
  const menuDrawer = document.getElementById('Details-menu-drawer-container');
  if (!menuDrawer) return;

  const unlockScroll = () => {
    setTimeout(() => {
      const classesToRemove = [
        'menu-open',
        'overflow-hidden',
        'overflow-hidden-tablet',
        'js-drawer-open',
        'lock-scroll',
        'scroll-lock'
      ];

      document.body.classList.remove(...classesToRemove);
      document.documentElement.classList.remove(...classesToRemove);

      document.body.style.overflow = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.height = '';

      console.log('%c✅ Scroll destravado (forçado)', 'color: limegreen; font-weight: bold');
    }, 100);
  };

  const lockScroll = () => {
    document.body.classList.add('menu-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';
  };

  // Histórico de menus (para voltar com <)
  let menuHistory = [];
  const menus = menuDrawer.querySelectorAll('.menu-drawer__panel');

  const showMenu = (menu) => {
    menus.forEach(m => m.classList.remove('is-active'));
    menu.classList.add('is-active');
  };

  // Fecha tudo (usado pelo X e quando não há histórico)
  const closeAllMenus = () => {
    console.log('❌ Fechando TODO o menu drawer');
    unlockScroll();
    // Fecha o drawer principal
    menuDrawer.removeAttribute('open');
    menuDrawer.open = false;

    // Reseta histórico
    menuHistory = [];

    // Opcional: fecha também qualquer <details> aberto
    menuDrawer.querySelectorAll('details[open]').forEach(d => d.removeAttribute('open'));
  };

  // Detecta abertura/fechamento do <details> principal
  menuDrawer.addEventListener('toggle', () => {
    if (menuDrawer.open) {
      lockScroll();
    } else {
      unlockScroll();
    }
  });

  // 🔙 Botão de VOLTAR (<)
  menuDrawer.querySelectorAll('[data-action="back"]').forEach(backBtn => {
    backBtn.addEventListener('click', (e) => {
      console.log('⬅️ Clicou em VOLTAR');

      if (menuHistory.length > 0) {
        // Volta apenas um nível do histórico
        const prevMenu = menuHistory.pop();
        showMenu(prevMenu);
      } else {
        console.log('⚠️ Nenhum menu anterior → fecha tudo');
        closeAllMenus();
      }

      e.stopPropagation(); // impede fechar por engano
    });
  });

  // ❌ Botão de FECHAR TUDO (span com data-action="close")
  menuDrawer.querySelectorAll('[data-action="close"]').forEach(closeBtn => {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      closeAllMenus();
    });
  });

  // ❌ Clique direto no SVG do X
  menuDrawer.querySelectorAll('svg.icon.icon-close').forEach(svg => {
    svg.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation(); // impede propagação para <summary>
      closeAllMenus();
    });
  });

  // Ao abrir submenu → salva histórico
  document.querySelectorAll('[data-submenu]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const submenuId = trigger.dataset.submenu;
      const submenu = document.getElementById(submenuId);
      const currentMenu = menuDrawer.querySelector('.menu-drawer__panel.is-active');

      if (currentMenu) menuHistory.push(currentMenu);
      if (submenu) showMenu(submenu);
    });
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-filter-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ==========================================================
     Helpers de DOM
     ========================================================== */

  // #MainContent é onde o Shopify renderiza as sections do template da
  // home; <main> é fallback pra outros temas/variações. Header e footer
  // ficam fora dessa área, então nunca aparecem na lista de "alvos".
  function getMain() {
    return document.querySelector('#MainContent, main');
  }

  // Sobe da barra até o wrapper .shopify-section que a Shopify gera pra
  // ela, pra nunca escondermos a nós mesmos.
  function getOwnWrapper(bar) {
    return bar.closest('.shopify-section');
  }

  function getAllSections(bar) {
    var main = getMain();
    if (!main) return [];
    return Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
  }

  // Só as sections que vêm DEPOIS da barra no HTML (ex: as sections
  // temáticas da home) entram na lista de "esconder". Um banner/hero
  // que fique ANTES da barra nunca é tocado — é assim que a referência
  // visual funciona: banner sempre visível, só o conteúdo abaixo da
  // barra é substituído pelo grid do kit.
  function getSectionsToToggle(bar) {
    var ownWrapper = getOwnWrapper(bar);
    var all = getAllSections(bar);
    var ownIndex = all.indexOf(ownWrapper);
    if (ownIndex === -1) return all.filter(function (sec) { return sec !== ownWrapper; });
    return all.filter(function (sec, i) { return i > ownIndex; });
  }

  function getPills(bar) {
    return Array.prototype.slice.call(bar.querySelectorAll('[data-kit]'));
  }

  function getViews(bar) {
    return Array.prototype.slice.call(bar.querySelectorAll('.kit-collection-view'));
  }

  /* ==========================================================
     Entrada/saída animada do grid de um kit (ver comentário no
     bloco de CSS acima sobre por que só a entrada é animada).
     ========================================================== */
  function showView(view) {
    view.removeAttribute('hidden');
    view.classList.add('kit-entering');
    // duplo rAF: garante que o navegador pintou o frame com opacity:0
    // ANTES de tirar a classe — senão a transição não roda.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        view.classList.remove('kit-entering');
      });
    });
  }

  function hideView(view) {
    view.setAttribute('hidden', '');
    view.classList.remove('kit-entering');
  }

  function setActivePill(bar, kitHandle) {
    getPills(bar).forEach(function (pill) {
      var isActive = pill.getAttribute('data-kit') === kitHandle;
      pill.classList.toggle('is-active', isActive);
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  // Scroll suave até o topo da barra, considerando o offset do header
  // sticky (--kfb-sticky-offset, atualizado continuamente mais abaixo).
  function scrollToBarTop(bar) {
    var navEl = bar.querySelector('[data-kfb-bar]');
    if (!navEl) return;
    var offset = parseFloat(getComputedStyle(bar).getPropertyValue('--kfb-sticky-offset')) || 0;
    var top = window.scrollY + navEl.getBoundingClientRect().top - offset;
    window.scrollTo({ top: top, left: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
  }

  /* ==========================================================
     Núcleo: aplica (ou remove) o filtro de um kit.
     ========================================================== */
  function applyKit(bar, kitHandle, options) {
    var opts = options || {};
    var sectionsToToggle = getSectionsToToggle(bar);
    var views = getViews(bar);

    // ---- "TODOS OS KITS": restaura tudo, sem precisar guardar estado ----
    if (kitHandle === 'all' || !kitHandle) {
      document.body.classList.remove('kit-filter-active');
      sectionsToToggle.forEach(function (sec) {
        sec.classList.remove('kit-hidden');
      });
      views.forEach(function (view) {
        hideView(view);
      });
      setActivePill(bar, 'all');
      if (!opts.skipHistory) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      return;
    }

    // ---- Fail-safe: kit sem grid correspondente, não faz nada ----
    var targetView = null;
    views.forEach(function (view) {
      if (view.getAttribute('data-kit-view') === kitHandle) targetView = view;
    });
    if (!targetView) {
      console.warn('[kit-filter-bar] Nenhum grid encontrado para o kit "' + kitHandle + '". Verifique o kit_handle configurado no block.');
      return;
    }

    // ---- Esconde as sections da home que vêm depois da barra (banner/hero
    //      antes dela nunca é tocado — ver getSectionsToToggle) ----
    document.body.classList.add('kit-filter-active');
    sectionsToToggle.forEach(function (sec) {
      sec.classList.add('kit-hidden');
    });

    // ---- Mostra só o grid do kit clicado ----
    views.forEach(function (view) {
      if (view === targetView) showView(view); else hideView(view);
    });

    setActivePill(bar, kitHandle);

    if (!opts.skipHistory) {
      history.replaceState(null, '', '#kit=' + encodeURIComponent(kitHandle));
    }
    if (!opts.skipScroll) {
      scrollToBarTop(bar);
    }
  }

  /* ==========================================================
     Inicialização de uma instância da barra
     ========================================================== */
  function initBar(bar) {
    if (!bar || bar.dataset.kfbInit === 'true') return;
    bar.dataset.kfbInit = 'true';

    var track = bar.querySelector('[data-kfb-track]');
    var navEl = bar.querySelector('[data-kfb-bar]');
    var prevArrow = bar.querySelector('[data-kfb-arrow="prev"]');
    var nextArrow = bar.querySelector('[data-kfb-arrow="next"]');
    if (!track || !navEl) return;

    /* ---- Listener único na barra, via event delegation ---- */
    track.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-kit]');
      if (!pill || !track.contains(pill)) return;
      applyKit(bar, pill.getAttribute('data-kit'));
    });

    /* ---- Setas de navegação horizontal (desktop) ---- */
    function scrollTrackBy(amount) {
      track.scrollBy({ left: amount, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    }
    if (prevArrow) prevArrow.addEventListener('click', function () { scrollTrackBy(-220); });
    if (nextArrow) nextArrow.addEventListener('click', function () { scrollTrackBy(220); });

    /* ---- Offset dinâmico + estado "presa" (.is-stuck) ----
       Tudo num loop só, frame a frame durante o scroll:

       1. offset = borda de BAIXO do header no viewport (0 quando ele está
          escondido; a altura dele quando visível/revelado). A barra presa
          fica em top: offset — sempre encostada logo abaixo do header.

       2. A barra só gruda quando o TOPO NATURAL dela passa ACIMA desse
          offset. O topo natural é medido pelo próprio root (bar): ele fica
          no fluxo mesmo quando a nav vira fixed (o spacer preserva a
          altura), e o topo dele não depende de nenhum div vazio — divs
          vazios são escondidos pelo reset "div:empty" do base.css, que já
          quebrou uma versão anterior desta lógica baseada em sentinela.
          Comparar com o offset — e não com o topo do viewport — faz o
          handoff fluxo↔fixed acontecer exatamente no ponto em que as duas
          posições coincidem, sem pulo, nos dois sentidos e com o header
          visível ou escondido.

       O header revela/esconde com transition de transform (~150ms, ver
       header.liquid + base.css) que continua rodando depois que o scroll
       para. Por isso o loop segue por mais 300ms após o último evento de
       scroll/resize — tempo de sobra pra transição terminar — e então
       para sozinho (custo zero com a página parada). */
    var offsetRafId = null;
    var offsetTrackUntil = 0;
    function updateStickyOffset() {
      // BF2026: o layout usa o bf-header (sticky só no desktop) + a barra flutuante e a faixa animada no mobile.
      // O offset é a borda inferior da mais baixa dessas barras que esteja presa ao topo agora.
      var offset = 0;
      ['.bf-header-section', '[data-bf-topfloat].is-visible', '.bf-marquee-section'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el) return;
        var pos = getComputedStyle(el).position;
        if (pos !== 'sticky' && pos !== 'fixed') return;
        offset = Math.max(offset, el.getBoundingClientRect().bottom);
      });
      // IMPORTANTE: setar no root da barra, NÃO no documentElement —
      // .kit-filter-bar-root declara --kfb-sticky-offset: 0px localmente,
      // e uma declaração local sempre vence a herdada pros descendentes
      // (a nav ficaria com top: 0 pra sempre).
      bar.style.setProperty('--kfb-sticky-offset', offset + 'px');

      navEl.classList.toggle('is-stuck', bar.getBoundingClientRect().top < offset);

      if (performance.now() < offsetTrackUntil) {
        offsetRafId = requestAnimationFrame(updateStickyOffset);
      } else {
        offsetRafId = null;
      }
    }
    function requestOffsetUpdate() {
      offsetTrackUntil = performance.now() + 300;
      if (offsetRafId === null) {
        offsetRafId = requestAnimationFrame(updateStickyOffset);
      }
    }
    window.addEventListener('scroll', requestOffsetUpdate, { passive: true });
    window.addEventListener('resize', requestOffsetUpdate);
    // O layout muda sem scroll: imagens height:auto carregando (ex: o
    // mini-banner acima da barra) empurram a posição natural dela pra
    // baixo. Sem reavaliar aqui, um estado calculado na carga (antes das
    // imagens) ficaria congelado errado até o primeiro scroll.
    if ('ResizeObserver' in window) {
      new ResizeObserver(requestOffsetUpdate).observe(document.body);
    }
    window.addEventListener('load', requestOffsetUpdate);
    requestOffsetUpdate();

    /* ---- Altura real da nav, usada pelo .kit-filter-bar__spacer pra
       reservar o espaço quando a barra vira "fixed" (.is-stuck) ---- */
    function updateBarHeight() {
      bar.style.setProperty('--kfb-bar-height', navEl.getBoundingClientRect().height + 'px');
    }
    window.addEventListener('resize', updateBarHeight);
    updateBarHeight();

    /* ---- Aplica o hash da URL no carregamento (#kit=casal) ---- */
    var match = /^#kit=([^&]+)$/.exec(window.location.hash);
    if (match) {
      var handleFromHash = decodeURIComponent(match[1]);
      var hasPill = getPills(bar).some(function (pill) {
        return pill.getAttribute('data-kit') === handleFromHash;
      });
      if (hasPill) applyKit(bar, handleFromHash, { skipHistory: true, skipScroll: true });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-kit-filter-bar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ==========================================================
     Compatibilidade com o editor de temas.
     ========================================================== */

  // Resolve o wrapper .shopify-section a partir do "target" de um evento
  // shopify:section:* (que pode ser o próprio wrapper ou algo dentro dele).
  function resolveSectionEl(target) {
    if (!target || !target.closest) return null;
    if (target.classList && target.classList.contains('shopify-section')) return target;
    return target.querySelector('.shopify-section') || target.closest('.shopify-section');
  }

  // Uma section (nossa ou de terceiros) foi recarregada pelo editor: se for
  // a nossa própria barra, reinicializa do zero (o hash na URL persiste
  // entre reloads, então applyHashOnLoad restaura o filtro ativo sozinho).
  // Se for QUALQUER outra section e um filtro estiver ativo, ela chega com
  // HTML "limpo" (sem .kit-hidden) e precisa ser escondida de novo.
  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = resolveSectionEl(event.target);
    var bar = sectionEl ? sectionEl.querySelector('[data-kit-filter-bar]') : null;

    if (bar) {
      initBar(bar);
      return;
    }

    if (sectionEl && document.body.classList.contains('kit-filter-active')) {
      // Só re-esconde se essa section estiver na zona "depois da barra" —
      // um banner/hero antes dela nunca deve ganhar .kit-hidden de volta.
      var anyBar = document.querySelector('[data-kit-filter-bar]');
      if (anyBar && getSectionsToToggle(anyBar).indexOf(sectionEl) !== -1) {
        sectionEl.classList.add('kit-hidden');
      }
    }
  });

  // Selecionar qualquer section no editor restaura a visão padrão, pra o
  // merchant nunca ficar tentando editar uma section escondida pelo filtro.
  document.addEventListener('shopify:section:select', function (event) {
    var sectionEl = resolveSectionEl(event.target);
    var bar = sectionEl ? sectionEl.querySelector('[data-kit-filter-bar]') : null;

    if (bar) {
      initBar(bar);
      return;
    }

    document.querySelectorAll('[data-kit-filter-bar]').forEach(function (barEl) {
      applyKit(barEl, 'all');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
